import mainConfig from "../common/config/main.config";
import request from "../common/requests/request";
import { GetCategoryListParams } from "../common/types";
import stringUtils from "../common/utils/stringUtils";

const getCategoryProducts = (params: GetCategoryListParams, store: string, eventEditionId: string) => {
  const { buName, eventGbsCode, categoryName } = params;
  const baseMagentoApiUrl = mainConfig.getConfig(process.env.REACT_APP_ENVIRONMENT).baseMagentoApiUrl;
  const modifiedBuName = buName && buName.toLowerCase().replace("_", "-");
  const returnFields = `children_count
    id
    url_path
    url_key
    id
    products(pageSize: 1000) {
      total_count
      items {
        ... on GroupedProduct {
          sku
          name
          rx_contact_type
          rx_customer_type
          rx_ebs_product_code
          rx_entitlement_id
          rx_event_edition_code
          rx_entitlement_child
          rx_print_at
          rx_link_type
          rx_description
          rx_markdown_description
          rx_restrict_purchase
          rx_shared_logo_usage
          rx_type
          price {
            regularPrice {
              adjustments {
                 code
                 amount { value currency }
              }
            }
          }
          price_range {
            minimum_price {
              regular_price {
                value
                currency
              }
            }
            maximum_price {
              regular_price {
                value
                currency
              }
            }
          }
          items {
            qty
            position
            product {
              ... on VirtualProduct {
                sku
                name
                url_key
                virtual_qty_available
                rx_addon_index
                __typename
              }
              price {
                regularPrice {
                  adjustments {
                    code
                    amount {
                      value
                      currency
                    }
                  }
                }
              }
              price_range {
                minimum_price {
                  regular_price {
                    value
                    currency
                  }
                }
                maximum_price {
                  regular_price {
                    value
                    currency
                  }
                }
              }
            }
          }
          __typename
        }
        ... on BundleProduct {
          bundle_qty_available
          id
          categories{
            id
            name
            description
          }
          price {
            regularPrice {
              adjustments {
                 code
                 amount { value currency }
              }
            }
          }
          dynamic_price
          price_range {
            minimum_price {
              regular_price {
                value
                currency
              }
            }
            maximum_price {
              regular_price {
                value
                currency
              }
            }
          }
          sku
          name
          short_description {
            html
          }
          description {
            html
          }
          stock_status
          rx_available_from
          rx_available_to
          rx_start_date
          rx_end_date
          rx_print_at
          rx_ebs_product_code
          rx_ebs_price_list_id
          rx_type
          rx_customer_type
          rx_entitlement_id
          rx_badge_name
          rx_badge_bar_background_colour
          rx_registration_accreditation
          rx_badge_bar_font_colour
          rx_badge_bar_letter
          rx_badge_suffix
          rx_event_edition_code
          rx_contact_type
          rx_description
          rx_restrict_purchase
          rx_markdown_description
          rx_shared_logo_usage
          rx_request_quote
          rx_link_type
          __typename
          url_key
          rx_description
          rx_max_cart_qty
          items {
            position
            uid
            option_id
            required
            options {
              uid
              label
              id
              price
              quantity
              product {
                ... on VirtualProduct {
                  rx_badge_name
                  rx_badge_bar_letter
                  rx_badge_bar_background_colour
                  rx_badge_bar_font_colour
                  virtual_qty_available
                  rx_badge_icon
                  rx_badge_icon_priority
                  rx_markdown_description
                  sku
                  stock_status
                  rx_max_cart_qty
                  rx_addon_index
                  rx_type
                  name
                }
                price {
                  regularPrice {
                    adjustments {
                      code
                      amount {
                        value
                        currency
                      }
                    }
                  }
                }
                price_range {
                  minimum_price {
                    regular_price {
                      value
                      currency
                    }
                  }
                  maximum_price {
                    regular_price {
                      value
                      currency
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    `;

  const query = `{
                categoryList(filters: { url_path: { eq: "${modifiedBuName}/${eventGbsCode}/${categoryName}" } }) {
                  ${returnFields}
                }
              }
            `;

  return request.getRequest(`${baseMagentoApiUrl}/graphql?query=${stringUtils.removeExtraSpaces(query)}`, { store, eventEditionId });
};

const MagentoService = {
  getCategoryProducts
};

export default MagentoService;
